import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mainCon widthRole2" }
const _hoisted_2 = { class: "bannerLit widthRole2" }
const _hoisted_3 = { class: "menuTr" }
const _hoisted_4 = { class: "menuDiv widthRole menuDiv1" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  class: "menu",
  id: "menu"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://caa-upload.cacpaper.com/nivdf2023/notice6.13.pdf",
    target: "_blank"
  }, "会议通知")
], -1)
const _hoisted_8 = { class: "menuDiv widthRole menuDiv2" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  class: "menu",
  id: "menu"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://caa-upload.cacpaper.com/nivdf2023/notice6.13.pdf",
    target: "_blank"
  }, "会议通知")
], -1)
const _hoisted_12 = { class: "widthRole flexC allFoot" }
const _hoisted_13 = { class: "leftF" }
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "size18" }, "友情链接", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", null, "中国自动化学会", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1)
const _hoisted_18 = { class: "contC" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "size18 ttl12" }, "联系我们", -1)
const _hoisted_20 = { class: "contactI flexC" }
const _hoisted_21 = { class: "contactItem" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "size16 tt2" }, "组委会联系方式", -1)
const _hoisted_23 = ["src"]
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "联系人：唐老师 屈老师", -1)
const _hoisted_25 = ["src"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "联系邮箱: caa@ia.ac.cn", -1)
const _hoisted_27 = { class: "contactItem" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "size16 tt2" }, " ", -1)
const _hoisted_29 = ["src"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "联系电话：010-82544541", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "tab1" }, "010-82544542", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "clr22" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "widthRole copyRight" }, " @ CopyRight 2023 网站版权所有 ", -1)

import { ref } from "vue";
  
  import iconEmail from '@/assets/img/icon_email.png'
  import icon_user from '@/assets/img/icon_user.png'
  import icon_phone from '@/assets/img/icon_phone.png'
  import logo from '@/assets/img/logo.png'
  // 菜单的当前高亮数值
  
export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

  const menuActiveNum = ref(1)
  const move = function(num:number){
      console.log('click', num);
      menuActiveNum.value = num
      menuShow.value = false
  }
  // 菜单 ul是否显示
  const menuShow = ref(false)
  const toggleMenu = function(){
      console.log(menuShow.value)
      menuShow.value = !menuShow.value
      console.log(menuShow.value)
  }
  
  
return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo"
          }, null, 8, _hoisted_5),
          _createElementVNode("ul", _hoisted_6, [
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 1 ? 'activeMenu' : ''),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (move(1)))
            }, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 5 ? 'activeMenu' : ''),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (move(5)))
            }, [
              _createVNode(_component_router_link, {
                to: "/support",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("参展和赞助")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 8 ? 'activeMenu' : ''),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (move(8)))
            }, [
              _createVNode(_component_router_link, {
                to: "/submission",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("论文投稿")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 6 ? 'activeMenu' : ''),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (move(6)))
            }, [
              _createVNode(_component_router_link, {
                to: "/meetingRegist",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("参会注册")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 7 ? 'activeMenu' : ''),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (move(7)))
            }, [
              _createVNode(_component_router_link, {
                to: "/previous",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("历届回顾")
                ]),
                _: 1
              })
            ], 2),
            _hoisted_7
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo"
          }, null, 8, _hoisted_9),
          _createElementVNode("span", {
            class: "menuIcon",
            ref: "menuIcon",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (toggleMenu()))
          }, null, 512),
          _withDirectives(_createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 1 ? 'activeMenu' : ''),
              onClick: _cache[6] || (_cache[6] = ($event: any) => (move(1)))
            }, [
              _createVNode(_component_router_link, { to: "/" }, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 5 ? 'activeMenu' : ''),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (move(5)))
            }, [
              _createVNode(_component_router_link, {
                to: "/support",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("参展和赞助")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 8 ? 'activeMenu' : ''),
              onClick: _cache[8] || (_cache[8] = ($event: any) => (move(8)))
            }, [
              _createVNode(_component_router_link, {
                to: "/submission",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("论文投稿")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 6 ? 'activeMenu' : ''),
              onClick: _cache[9] || (_cache[9] = ($event: any) => (move(6)))
            }, [
              _createVNode(_component_router_link, {
                to: "/meetingRegist",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("参会注册")
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(menuActiveNum.value === 7 ? 'activeMenu' : ''),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (move(7)))
            }, [
              _createVNode(_component_router_link, {
                to: "/previous",
                tag: "li"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("历届回顾")
                ]),
                _: 1
              })
            ], 2),
            _hoisted_11
          ], 512), [
            [_vShow, menuShow.value]
          ])
        ])
      ])
    ]),
    _createVNode(_component_router_view),
    _createElementVNode("footer", null, [
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("img", {
            src: _unref(logo),
            alt: "logo",
            class: "footerLogo"
          }, null, 8, _hoisted_14),
          _hoisted_15,
          _hoisted_16
        ]),
        _hoisted_17,
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _hoisted_22,
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _unref(icon_user),
                  class: "ic-user"
                }, null, 8, _hoisted_23),
                _hoisted_24
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _unref(iconEmail),
                  class: "ic-email"
                }, null, 8, _hoisted_25),
                _hoisted_26
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _createElementVNode("div", null, [
                _createElementVNode("img", {
                  src: _unref(icon_phone),
                  class: "ic-phone"
                }, null, 8, _hoisted_29),
                _hoisted_30
              ]),
              _hoisted_31
            ]),
            _hoisted_32
          ])
        ])
      ]),
      _hoisted_33,
      _hoisted_34
    ])
  ]))
}
}

})